import { render } from "./OrderTMStatusChip.vue?vue&type=template&id=2658af28&scoped=true"
import script from "./OrderTMStatusChip.vue?vue&type=script&lang=js"
export * from "./OrderTMStatusChip.vue?vue&type=script&lang=js"

import "./OrderTMStatusChip.vue?vue&type=style&index=0&id=2658af28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2658af28"]])

export default __exports__